import { render, staticRenderFns } from "./ClassificationDegreeChangeActivationType.vue?vue&type=template&id=718e7c86&"
import script from "./ClassificationDegreeChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./ClassificationDegreeChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports